import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@libs/index';
import { takeUntil } from 'rxjs/operators';

export interface ImageFullsizeViewDialogComponentData {
  images: string[];
  selectedIndex?: number;
}

@Component({
  selector: 'app-image-fullsize-view-dialog',
  templateUrl: './image-fullsize-view-dialog.component.html',
  styleUrls: ['./image-fullsize-view-dialog.component.scss'],
})
export class ImageFullsizeViewDialogComponent extends BaseComponent {
  public imageToDisplay: string;

  private selectedImageIndexControl: FormControl;
  private images: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImageFullsizeViewDialogComponentData,
    private dialogRef: MatDialogRef<ImageFullsizeViewDialogComponent>
  ) {
    super();

    this.selectedImageIndexControl = new FormControl(null);

    this.selectedImageIndexControl.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((value) => this.updateImageToDisplay(value));

    this.images = this.data?.images;

    this.selectedImageIndexControl.setValue(this.data?.selectedIndex || 0);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public nextImage(): void {
    this.selectedImageIndexControl.setValue(
      (this.selectedImageIndexControl.value + 1 + this.images.length) %
        this.images.length
    );
  }

  public previousImage(): void {
    this.selectedImageIndexControl.setValue(
      (this.selectedImageIndexControl.value - 1 + this.images.length) %
        this.images.length
    );
  }

  private updateImageToDisplay(value: number): void {
    if (!this.images?.length) {
      return;
    }

    this.imageToDisplay =
      this.images[(value + this.images.length) % this.images.length];
  }
}
